import React from "react";
import { Link } from "react-router-dom";

const PaymentCancel = () => (
  <div
    className="px-6 md:px-10 max-w-[720px] mx-auto py-24 text-center"
    data-testid="payment-cancel-page"
  >
    <p className="font-serif italic text-[color:var(--ink-mute)]">Checkout cancelled</p>
    <h1 className="font-serif text-5xl mt-4 leading-[1.1]">No worries.</h1>
    <p className="font-serif text-xl text-[color:var(--ink-mute)] mt-6">
      Your cart is still saved. You can review it and try again whenever you're ready.
    </p>
    <div className="mt-10 flex items-center justify-center gap-6">
      <Link to="/cart" className="font-serif italic tlink">Back to cart →</Link>
      <Link to="/shop" className="font-serif italic tlink tlink-mute">Keep browsing</Link>
    </div>
  </div>
);

export default PaymentCancel;
